"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Line = void 0;
const point_1 = require("./point");
const types_1 = require("./types");
const rectangle_1 = require("./rectangle");
const utilities_1 = require("./utilities");
class Line {
    pt1;
    pt2;
    rectangle;
    constructor(x1, y1, x2, y2) {
        this.pt1 = new point_1.Point(x1, y1);
        this.pt2 = new point_1.Point(x2, y2);
        this.rectangle = new rectangle_1.Rectangle(x1, y1, 1, 1);
        this.rectangle.unionPoint(new point_1.Point(x2, y2));
    }
    ;
    // <editor-fold defaultstate="collapsed" desc="Public Functions">
    getShapeType() {
        return types_1.ShapeTypes.LINE;
    }
    ;
    getBounds() {
        return new rectangle_1.Rectangle(this.rectangle.getX(), this.rectangle.getY(), this.rectangle.getWidth(), this.rectangle.getHeight());
    }
    ;
    getP1() {
        return this.pt1;
    }
    ;
    getP2() {
        return this.pt2;
    }
    ;
    shift(x, y) {
        this.rectangle.shift(x, y);
        this.pt1.shift(x, y);
        this.pt2.shift(x, y);
    }
    ;
    /**
 * Tests if the specified line segment intersects this line segment.
 * @param line the specified <code>Line</code>
 * @return <code>true</code> if this line segment and the specified line
 *			segment intersect each other;
 *			<code>false</code> otherwise.
 */
    intersectsLine(line) {
        return utilities_1.ShapeUtilties.linesIntersect(this.getP1().getX(), this.getP1().getY(), this.getP2().getX(), this.getP2().getY(), line.getP1().getX(), line.getP1().getY(), line.getP2().getX(), line.getP2().getY());
    }
    ;
    setPath(context) {
        //context.beginPath();
        context.moveTo(this.pt1.getX(), this.pt1.getY());
        context.lineTo(this.pt2.getX(), this.pt2.getY());
    }
    ;
    stroke(context) {
        context.beginPath();
        context.moveTo(this.pt1.getX(), this.pt1.getY());
        context.lineTo(this.pt2.getX(), this.pt2.getY());
        context.stroke();
    }
    ;
    fill(context) {
        context.beginPath();
        context.moveTo(this.pt1.getX(), this.pt1.getY());
        context.lineTo(this.pt2.getX(), this.pt2.getY());
        context.fill();
    }
    ;
    toSVGElement(stroke, strokeWidth, fill) {
        var line = '<line x1="' + this.pt1.getX() + '" y1="' + this.pt1.getY();
        line += '" x2="' + this.pt2.getX() + '" y2="' + this.pt2.getY() + '"';
        if (strokeWidth)
            line += ' stroke-width="' + strokeWidth + '"';
        else if (stroke)
            line += ' stroke-width="2"';
        if (stroke)
            line += ' stroke="' + stroke + '"';
        if (fill)
            line += ' fill="' + fill + '"';
        else
            line += ' fill="none"';
        line += '/>';
        return line;
    }
    ;
}
exports.Line = Line;
//# sourceMappingURL=line.js.map